// useMarkConversationRead.js
import userResources from "api/userResources";
import { useEffect } from "react";

export const useMarkConversationRead = (conversationId) => {
  useEffect(() => {
    const markAsConversationRead = async (id) => {
      if (!id) return;

      try {
        await userResources.markConversationRead(id);
      } catch (error) {
        console.error("Failed to mark conversation as read:", error);
      }
    };

    markAsConversationRead(conversationId);
  }, [conversationId]);
};
